import { createSlice } from '@reduxjs/toolkit'
import { SUPPLY_VIEW_ID_SUMMARY } from 'helpers/constants'

const supplyActualsInitialState = {
  firstLoadFilterData: [],
  selectedProgram: { displayText: '', id: '' },
  selectedSupplyView: { displayText: 'Supply Summary', id: SUPPLY_VIEW_ID_SUMMARY },
  selectedYear: { displayText: '', id: '' },
  selectedCropCycle: [],
  selectedTypeOfPotato: [],
  selectedVariety: [],
  selectedReceiver: { displayText: '', id: '' },
  selectedSupplyStage: { displayText: '', id: '' },
  selectedSupplier: [],
  supplierOptions: [],
  programGeneralSettings: {},
  programms: [],
  yearOptions: [],
  varietyOptions: [],
  supplyStageOptions: [],
  shareExtractPageDropdownOptions: {
    supplierOptions: [],
    varietyOptions: [],
    supplyStageOptions: [],
    typeOfPotatoOptions: [],
  },
  classificationData: {
    seed: {},
    minituber: {},
    plantlet: {},
  },
}

export const supplyActualsSlice = createSlice({
  name: 'supplyActuals',
  initialState: supplyActualsInitialState,
  reducers: {
    setFilterData: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setProgramGenralSettings: (state, action) => ({
      ...state,
      programGeneralSettings: action.payload,
    }),
    setSupplyProgram: (state, action) => ({
      ...state,
      programms: action.payload,
    }),
    setSupplyYearOptions: (state, action) => ({
      ...state,
      yearOptions: action.payload,
    }),
    setClassificationData: (state, action) => ({
      ...state,
      classificationData: {
        ...state.classificationData,
        ...action.payload,
      },
    }),
    setSupplierOptions: (state, action) => ({
      ...state,
      supplierOptions: action.payload,
    }),
    setFirstLoadFilterData: (state, action) => ({
      ...state,
      firstLoadFilterData: action.payload,
    }),
    setSelectedVariety: (state, action) => ({
      ...state,
      selectedVariety: action.payload,
    }),
    setShareExtractPageDropdownSupplierOptions: (state, action) => ({
      ...state,
      shareExtractPageDropdownOptions: {
        ...state.shareExtractPageDropdownOptions,
        supplierOptions: action.payload,
      },
    }),
    setShareExtractPageDropdownVarietyOptions: (state, action) => ({
      ...state,
      shareExtractPageDropdownOptions: {
        ...state.shareExtractPageDropdownOptions,
        varietyOptions: action.payload,
      },
    }),
    setShareExtractPageDropdownSupplyStageOptions: (state, action) => ({
      ...state,
      shareExtractPageDropdownOptions: {
        ...state.shareExtractPageDropdownOptions,
        supplyStageOptions: action.payload,
      },
    }),
    setShareExtractPageDropdownTypeOfPotatoOptions: (state, action) => ({
      ...state,
      shareExtractPageDropdownOptions: {
        ...state.shareExtractPageDropdownOptions,
        typeOfPotatoOptions: action.payload,
      },
    }),
  },
})

export const {
  setFilterData,
  setProgramGenralSettings,
  setSupplyProgram,
  setSupplyYearOptions,
  setClassificationData,
  setSupplierOptions,
  setFirstLoadFilterData,
  setShareExtractPageDropdownSupplierOptions,
  setShareExtractPageDropdownVarietyOptions,
  setShareExtractPageDropdownSupplyStageOptions,
  setShareExtractPageDropdownTypeOfPotatoOptions,
  setSelectedVariety,
} = supplyActualsSlice.actions

export default supplyActualsSlice.reducer
